export default __webpack_public_path__ + "static/media/13.099cdc66.png";